module.exports = __webpack_public_path__ + "static/media/ms.edb4b3c5.svg";